module.exports = __webpack_public_path__ + "img/11.2aaa25b1.jpg";